"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'MFourThree_1_0_0',
  heading1: '',
  heading2: '',
  textBlock: '',
  theme: 'light',
  textBlockPosition: 'left',
  cta: {
    URL: '#',
    label: 'Explore Outlander',
    priority: 'low',
    openNewTab: false
  },
  image: {
    altText: '',
    image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/outlander-hero.jpg'
  },
  video: {
    youtubeVideoId: '',
    source: ''
  }
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;